import { Flex, VStack } from '@chakra-ui/react'
import { useParams } from "react-router-dom";
import Block from '../components/shared/Block'
import { BsFileEarmarkArrowDown } from 'react-icons/bs'
import ListAttachments from '../components/formstep2/ListAttachments'
import { useState } from 'react';
import FormRequestContext, { defaultFormRequestValue } from '../context/formRequestContext';
import FormStepPanel from '../components/form/FormStepPanel';

const FormStep2 = () => {
    const { fid } = useParams();
    const [formReqData, setFormReqData] = useState(defaultFormRequestValue)

    return (
        <FormRequestContext.Provider value={[formReqData, setFormReqData]}>
            <Flex p="40px" direction="column" w="full">
                <Block title="ดาวน์โหลดแบบฟอร์มและแนบเอกสาร" icon={BsFileEarmarkArrowDown} >
                    <VStack w="full">
                        <FormStepPanel step={2} />
                        <ListAttachments fid={fid} />
                    </VStack>
                </Block>
            </Flex>
        </FormRequestContext.Provider>
    )
}

export default FormStep2